import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "commonPantryDialogOverlay" }
const _hoisted_2 = { class: "commonPantryDialogBox pantry-storage-value-dialog-box" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "commonPantryDialogHeaderArea" }, null, -1)
const _hoisted_4 = { class: "commonPantryTitleArea" }
const _hoisted_5 = { class: "commonPantryTitleText" }
const _hoisted_6 = { class: "pantry-storage-value-dialog-search-radio-list" }
const _hoisted_7 = { class: "pantry-storage-value-dialog-button-view-area" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "pantry-storage-value-dialog-white" }, [
  /*#__PURE__*/_createVNode("div", { class: "pantry-storage-value-dialog-text" }, "キャンセル")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "pantry-storage-value-dialog-black" }, [
  /*#__PURE__*/_createVNode("div", { class: "pantry-storage-value-dialog-text" }, "更新する")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryRadioItem = _resolveComponent("PantryRadioItem")

  return (_openBlock(), _createBlock(_Transition, { name: "pantry-storage-value-dialog" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.DETAIL_ITEM_TITLE.STORAGE), 1)
          ]),
          _createVNode("div", _hoisted_6, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PANTRY_NEW_STORAGE_TYPE, (item, key, index) => {
              return (_openBlock(), _createBlock(_component_PantryRadioItem, {
                class: "pantry-storage-value-dialog-radio",
                key: key,
                id: index,
                selectId: _ctx.selectId,
                valueText: item,
                onSelectCheck: _ctx.selectChecked
              }, null, 8, ["id", "selectId", "valueText", "onSelectCheck"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", {
              class: "pantry-storage-value-dialog-button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickClose(...args)))
            }, [
              _hoisted_8
            ]),
            _createVNode("div", {
              class: "pantry-storage-value-dialog-button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickSetting(...args)))
            }, [
              _hoisted_9
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}